module.exports = __webpack_public_path__ + "main/assets/public/meta-tags/subscribe_image.03c85994e4786896.png";